import React, { useMemo } from 'react';
import Dropdown from '@ott/dropdown-next-deprecated';

import { Control, useController, FieldPath } from 'react-hook-form';
import { FormState, TimeItem } from '../../../../types';
import DropdownTrigger from './blocks/DropdownTrigger';

import styles from './TimeDropdown.scss';

interface Props {
  name: FieldPath<FormState>;
  control: Control<FormState>;
  caption: string;
  isDark: boolean;
  triggerClassName?: string;
  testLocator?: string;
  items: TimeItem[];
}

const TimeDropdown: React.FC<Props> = (props) => {
  const { control, name, caption, isDark, triggerClassName, testLocator, items } = props;

  const {
    field: { value: valueId, onChange },
  } = useController({
    name,
    control,
  });

  const triggerProps = useMemo(() => {
    return {
      hasBorder: false,
      TriggerRenderer: (triggerRendererProps: any) =>
        DropdownTrigger({ caption, isDark, ...triggerRendererProps }),
      placeholder: caption,
      className: triggerClassName,
      'data-locator': testLocator,
    };
  }, [caption, triggerClassName, testLocator, isDark]);

  const overlayProps = useMemo(() => {
    return {
      className: styles.overlay,
      options: items,
      onChange: ({ id }: TimeItem) => onChange(id),
    };
  }, [onChange, items]);

  const foundValue = items.find((item) => item.id === valueId);
  const value = valueId && foundValue ? foundValue : null;

  return (
    // @ts-ignore
    <Dropdown
      mode="single"
      size="small"
      triggerProps={triggerProps}
      overlayProps={overlayProps}
      value={value}
    />
  );
};

export default TimeDropdown;
